import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import classNames from "classnames";
import "./index.scss";
import {Popover} from 'antd';

import { createAction } from "../../../utils/sagaHelper";

import IconButton from "../IconButton";
import {isRTL} from "../../../services/userModel.js";
import { ORDER_COMPENSATION_EDIT } from '../../../store/reducers/order/order-actions.js';

const CompensationEditor = ({ t, itemAction, id, defaultValue }) => {
    const [open, setOpen] = useState(false);
    const [currentValue, setCurrentValue] = useState(() => defaultValue || {
      'compensation': '',
      'notes': '',
    });

    const hasAnyValue = () => {
      return defaultValue?.compensation || defaultValue?.notes?.length;
    }

    const handleOnSetNote = () => {
        return new Promise((resolve, reject)=> {
              itemAction(ORDER_COMPENSATION_EDIT, { id, ...currentValue }).then(()=> {
                  resolve();
                  setOpen(false);
              }, error=> {
                  reject();
                  toast.error(error || "Error");
              });
        });
    }

    const handleOnCancel = () => {
        return new Promise(resolve=> {
            resolve();
            setOpen(false);
            setCurrentValue(defaultValue || currentValue);
        });                
    }

    const handleOnSetOpen = () => {
        return new Promise(resolve=> {
          resolve();
          setOpen(!open);
        });    
    }

    const handleOnChange = (key, event) => {
      const value = event.target.value;
      event.preventDefault();

      if(key === "compensation") {
        if(value.toString().split(".")?.[1]?.length > 2 || value.toString().split(",")?.[1]?.length > 2) {
          return;
        }
        setCurrentValue({...currentValue, [key]: value});
        return;
      }
      setCurrentValue({...currentValue, [key]: value});
    }

    const isDisableSave = () => {
      return !(currentValue.notes.length || currentValue.compensation);
    }

    return (
        <div className={classNames("compensationEditor")}>
            <Popover
                placement={isRTL() ? "right" : "left"}
                content={<div className={classNames("compensationPopover", {rtl: isRTL()})}>
                    <input value={currentValue.compensation} onChange={(event) => handleOnChange('compensation', event)} placeholder={t("orders.ORDER_COMPENSATION_PLACEHOLDER")} />
                    <textarea value={currentValue.notes} placeholder={t("orders.ORDER_NOTE_PLACEHOLDER")}
                              className={classNames("inputItem")}
                              onChange={e=> handleOnChange('notes', e)}
                    ></textarea>
                    <div className={classNames("controls")}>
                        <button className={classNames("btn", "confirm")} disabled={isDisableSave()} onClick={handleOnSetNote}>
                            {t("basic.SAVE_BUTTON")}
                        </button>
                        <button className={classNames("btn", "denied")} onClick={handleOnCancel}>
                            {t("basic.CANCEL_BUTTON")}
                        </button>
                    </div>
                </div>}
                trigger="click"
                open={open}
                onOpenChange={setOpen}
            />
            <IconButton
                isIcon={true}
                iconName={hasAnyValue() ? "driverTip hasValue": "driverTip"}
                tooltipText={t("orders.ORDER_COMPENSATION_TOOLTIP")}
                onClick={handleOnSetOpen}
            />
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        itemAction: (action, data) => dispatch(createAction(action, data)),
    };
};

export default connect(null, mapDispatchToProps)(withTranslation()(CompensationEditor));